import { render, staticRenderFns } from "./CoDoorList.vue?vue&type=template&id=38c6bfa6&scoped=true&"
import script from "./CoDoorList.vue?vue&type=script&lang=js&"
export * from "./CoDoorList.vue?vue&type=script&lang=js&"
import style0 from "@/assets/less/manage-space/base.less?vue&type=style&index=0&id=38c6bfa6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c6bfa6",
  null
  
)

export default component.exports